import { render, staticRenderFns } from "./GroupDescriptionWidget.vue?vue&type=template&id=f4331270&scoped=true&"
import script from "./GroupDescriptionWidget.vue?vue&type=script&lang=js&"
export * from "./GroupDescriptionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4331270",
  null
  
)

export default component.exports